import { toast } from "react-toastify";
import { BASE_URL } from "../api/routes";

export const GreenNotify = (text) => {
  toast.success(text, {
    position: toast.POSITION.TOP_CENTER,
  });

  // toast.error("Error Notification !", {
  //   position: toast.POSITION.TOP_LEFT,
  // });

  // toast.warn("Warning Notification !", {
  //   position: toast.POSITION.BOTTOM_LEFT,
  // });

  // toast.info("Info Notification !", {
  //   position: toast.POSITION.BOTTOM_CENTER,
  // });

  // toast("Custom Style Notification with css class!", {
  //   position: toast.POSITION.BOTTOM_RIGHT,
  //   className: "foo-bar",
  // });
};

export const RedNotify = (text) => {
  toast.error(text, {
    position: toast.POSITION.TOP_CENTER,
  });
};
// =================upload data ===================
// export const upload = (cb, setIsLoading) => (evt) => {
//   const files = evt.target.files;
//   const file = files[0];

//   var myHeaders = new Headers();
//   myHeaders.append(
//     "Authorization",
//     "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY2NGRlODczMTM1MWUwZTA5MDMxYjNhYyIsImlhdCI6MTcyMjk0NjIxMCwiZXhwIjoxODQyOTQ2MjEwfQ.Ltn1B_BJAMJ6wI-VvcfJQwjPHzyEOES1q-3LALfjW0w"
//   );

//   var formdata = new FormData();
//   formdata.append("file", file);

//   var requestOptions = {
//     method: "POST",
//     headers: myHeaders,
//     body: formdata,
//     redirect: "follow",
//   };
//   setIsLoading(true);
//   fetch(`${BASE_URL}user/upload`, requestOptions)
//     .then((response) => response.json())
//     .then((data) => {
//       const url = data.url;
//       setIsLoading(false);
//       cb(url);
//     })
//     .catch((error) => {
//       setIsLoading(false);
//       console.log("error", error);
//     });
// };

// export const uploadData = (file) => {
//   return new Promise((resolve, reject) => {
//     var myHeaders = new Headers();
//     myHeaders.append("Authorization", "your-token-here");

//     var formdata = new FormData();
//     formdata.append("file", file);

//     var requestOptions = {
//       method: "POST",
//       headers: myHeaders,
//       body: formdata,
//       redirect: "follow",
//     };

//     fetch(
//       "http://ec2-52-87-209-182.compute-1.amazonaws.com/user/upload",
//       requestOptions
//     )
//       .then((response) => response.json())
//       .then((data) => {
//         resolve(data.url);
//       })
//       .catch((error) => {
//         console.error("Error uploading file:", error);
//         reject(error);
//       });
//   });
// };
